import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../powershine-4.png";

function Navbar({ t, lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTo = (path) => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__inner">
        <button className="navbar__logo-btn" onClick={() => goTo("/")}>
          <img src={logo} alt="PowerShine" className="navbar__logo" />
        </button>

        <div className={`navbar__links ${menuOpen ? "navbar__links--open" : ""}`}>
          <button
            className={`navbar__link ${location.pathname === "/" ? "navbar__link--active" : ""}`}
            onClick={() => goTo("/")}
          >
            {t.nav.home}
          </button>
          <button
            className={`navbar__link ${location.pathname === "/contact" ? "navbar__link--active" : ""}`}
            onClick={() => goTo("/contact")}
          >
            {t.nav.contact}
          </button>
          <button
            className="navbar__cta"
            onClick={() => goTo("/contact")}
          >
            {t.hero.cta}
          </button>
        </div>

        <div className="navbar__right">
          <div className="lang-switcher">
            <button
              className={`lang-btn ${lang === "en" ? "lang-btn--active" : ""}`}
              onClick={() => setLang("en")}
            >
              EN
            </button>
            <span className="lang-divider">|</span>
            <button
              className={`lang-btn ${lang === "nl" ? "lang-btn--active" : ""}`}
              onClick={() => setLang("nl")}
            >
              NL
            </button>
          </div>
          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger__bar ${menuOpen ? "hamburger__bar--top-open" : ""}`} />
            <span className={`hamburger__bar ${menuOpen ? "hamburger__bar--mid-open" : ""}`} />
            <span className={`hamburger__bar ${menuOpen ? "hamburger__bar--bot-open" : ""}`} />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
